// extracted by mini-css-extract-plugin
export default {"item-container":"mochi-parking-tutorial-carousel_item-container__cHPvP","item-content":"mochi-parking-tutorial-carousel_item-content__4b12l"};